import React from "react";
import ReactDOM from "react-dom";
import AutoCompleteView from "./AutoCompleteView";

export default class AutoCompleteHeader {
    constructor(element) {
        this.element = element;
        this.view = element.querySelector("#js-autocomplete-header-root");
        this.init();
    }

    init() {
        ReactDOM.render(<AutoCompleteView />, document.getElementById("js-autocomplete-header-root"));
    }
}
